<template>
    <div>
        <h1 class="mb-4 font-active">lifetime warranty</h1>
        <p>
            Friendly Diamonds offers a FREE lifetime warranty against all manufacturing defects for all made-to-order and custom-made products. We stand by all the diamonds and jewelry pieces we sell and warrant that they are free of any manufacturing defects at the time of delivery. If you believe your piece is damaged, please get in touch with us for details on how to ship the item back to our quality control team for inspection. Shipping costs for both-way shipments of your item will be charged to you. 
            <br><br>
            Upon inspection, if a warranted issue is found, Friendly Diamonds will repair the warranted damage or replace the item without any costs to you. Such repairs include metal shouldering, setting of loose stones, prong tightening and cleaning service. We are unable to warrant items that have previously been repaired, resized or polished by someone other than Friendly Diamonds, replacement of lost or missing diamonds, normal wear and tear of items from regular use and discoloration of metal caused by chemicals and make up. If an issue that is not covered under our lifetime warranty policy is found, we will share a price quotation for your approval for such repairs before any work begins. 
        </p>

        <h2>Shipping Terms for Repaired Items</h2>
        
        <p>All repaired items are typically shipped within 7-10 business days from the date of receiving the item. In case we need to remake the item, it can take up to 2 weeks. For all international shipments, customs processes and import duties are the customer's responsibility; please check with your local customs office for information. Please refer to our <NuxtLink :to="localePath('/customer-service/shipping-policy')">shipping policy</NuxtLink> for more information. </p>


        <h2>How To Return Your Order?</h2>
        <h4>1. Contact Friendly Diamonds Customer Service Department</h4>
        <ul>
            <li>To send in your items for inspection, please don't hesitate to get in touch with us. Please  send us an email at <a rel="nofollow noopener" :href="'mailto:'+$country.email">{{$country.email}}</a> with your order number and the word "Repair" in the subject line and provide all the information regarding your request. </li>
            <li>A shipping label can be requested from our team to send in your items for inspection. Actual shipping costs for both-way shipments will be charged to you. </li>
        </ul>

        <h4>2. Pack Your Order</h4>
        <ul>
            <li>Ensure that the actual product and any loose diamonds or metal pieces are securely packed in the original packaging box. </li>
            <li>For security reasons, do not write ‘jewelry’, ‘diamonds’, or other related words anywhere on the package.</li>
            <li>For safety purposes, please double-box your package.</li>
            <li>Affix the label to the outside of the larger box and drop it off at your nearest courier company location (we recommend UPS, FedEx, or USPS as our preferred shipping partners).</li>
            <li>Friendly Diamonds cannot be held responsible for shipping errors – we recommend that customers only use a staffed store-front to send returned items. Please do not use drop boxes or non-staffed locations.</li>
            <li>Obtain a shipping receipt to confirm that the item has been shipped - this receipt will act as proof of shipment and insurance.</li>
            <li>Friendly Diamonds recommends purchasing insurance on the package up to the replacement value. </li>
        </ul>
        <p>
            Please note that our lifetime warranty only applies to manufacturing defects, not issues related to regular wear and tear, loss, or theft. To ensure your jewelry items are protected from unforeseen circumstances, we highly recommend insuring them regardless of the warranty.
        </p>
        <br>
        <p>
            Many of our customers rely on <a href="https://www.jewelersmutual.com/" target="_blank" rel="nofollow noopener"> Jewelers Mutual </a>  for hassle-free insurance coverage. With insurance coverage in place, you can file a claim with your insurance provider to obtain a replacement in any unfortunate event, such as loss or theft.
        </p>
    </div>
</template>

<script setup>
    const localePath = useLocalePath()
    const { $country } = useNuxtApp()
</script>

<style scoped>
.main_title {
    margin: 4% 0;
}
.main_title h2 {
    font-size: 40px;
    text-align: center;
}
h1{
    font-size: 32px;
    text-transform: capitalize;
}
p {
    margin-bottom: 0;
    color: #606060;
    font-size: 16px;
    font-weight: 500;
}
ul {
    margin-left: 25px;
    padding-left: 0;
}
ul li{
    color: #606060;
    font-size: 16px;
    font-weight: 500; 
}
h3, h2 {
    font-size: 21px;
    font-weight: 500;
    margin: 30px 0 20px;
}
h4{
    margin-bottom: 6px;
    color: #353535;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
}
a{
    color: var(--green);
    text-decoration: underline;
}


@media(max-width: 767px){
    .main_title h2{
        font-size: 32px;
    }
    .main_title {
        margin: 13% 0 10%;
    }
    h1{
        font-size: 20px;
    }
    h3, h2{
        font-size: 18px;
    }

    p {
        font-size: 14px;
    }
    ul li {
        font-size: 14px;
    }
}
</style>